import React, { useRef, useState, useEffect, Suspense } from 'react';
import { useAuth } from '../../context';
import { useNavigate } from 'react-router-dom';
import Topbar from './components/Topbar';
import Topbar2 from './components/Topbar2';
import { useLocation } from "react-router-dom";
import animationData from '../../assets/landing_pageV1/loader_animation.json';
import landingPageData from '../../assets/landing_pageV1/page1_top_animation.json';
import Lottie from 'react-lottie';
import styles from './styles/common.module.css';
import ZohoIQWidget from "../../utils/ZohoIQWidget";
import FormModal from './components/FormModal';
import SchoolAiPage from '../../components/SchoolAiPage';
import EnquiryDropdown from './components/EnquiryDropdown';
import EnquiryDrawer from './components/EnquiryDrawer';
import { routesLinks, trackButtonClick, trackScrollDepth, trackSelectedActions } from '../../utils/RouteConstants';
import Page1 from '../LandingPagev1/pages/page1'
import { useInView } from 'react-intersection-observer';
import ActionButton from '../LandingPagev1/components/ActionButton';
import navbarStyles from '../../styles/navbar2.module.css';
import logo from '../../assets/landing_pageV1/whiteheadphones.png';
import Page2Header from './pages/page2-header';
import Page2Content from './pages/page2-content';
import VoiceAgentPage from '../VoiceAgentPage/VoiceAgentPage';
import { useEnquiry } from '../../hooks/useEnquiry';

// Lazy load pages
const Page3 = React.lazy(() => import('./pages/page3'));
const Page4 = React.lazy(() => import('./pages/Page4'));
const Page5 = React.lazy(() => import('./pages/Page5'));
const Page6 = React.lazy(() => import('./pages/Page6'));
const Page7 = React.lazy(() => import('./pages/page7'));
const Page8 = React.lazy(() => import('./pages/page8'));
const Page9 = React.lazy(() => import('./pages/page9'));
const Page10 = React.lazy(() => import('./pages/page10'));

// Loader animation options
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const landingPageOptions = {
  loop: true,
  autoplay: true,
  animationData: landingPageData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const LandingPageV1 = () => {
  const { initialLoader, opacity, contentOpacity } = useAuth();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [visiblePages, setVisiblePages] = useState([0, 1, 2]);

  const {
    enquiryOpen,
    setEnquiryOpen,
    openSchoolForm,
    actionButtonRef,
    options,
    onOptionSelect,
    handleCloseForm,
    handleEnquiry
  } = useEnquiry();

  const showBoxes =
    (location.pathname === routesLinks.homev1 ||
      location.pathname === routesLinks.homev2) && isMobile;

  const hidePage1 = (location.pathname === routesLinks.homev1 ||
    location.pathname === routesLinks.homev2
  )

  const pages = [];
  if (!hidePage1) pages.push(<VoiceAgentPage key={0} handleBtnClick={handleEnquiry} />);

  pages.push(
    // handle the enquiryclick in voicepage
    <Page2Header key={1} handleBtnClick={handleEnquiry} isSales={hidePage1} showBoxes={showBoxes}/>,
    <Page2Content key={2} handleBtnClick={handleEnquiry} />,
    <Page3 key={3} handleBtnClick={handleEnquiry} />,
    <Page4 key={4} />,
    <Page5 key={5} handleBtnClick={handleEnquiry} />,
    <Page6 key={6} />,
    <Page7 key={7} handleBtnClick={handleEnquiry} />,
    <Page8 key={8} />,
    <Page9 key={9} handleBtnClick={handleEnquiry} />,
    <Page10 key={10} />
  );

  return (
    <div className={styles.container}>
      {initialLoader && (
        <div
          className={styles.loaderContainer}
          style={{ opacity: opacity }}
        >
          <div className={styles.lottieWrapper}>
            <Lottie options={defaultOptions} />
          </div>
        </div>
      )}
      {/* style={{ opacity: contentOpacity }} */}
      <div className={styles.contentContainer} >
        {/* {!(location.pathname === routesLinks.homev1 || 
            location.pathname === routesLinks.homev2) && (
            <div className={styles.landingPagelottieWrapper}>
              <Lottie options={landingPageOptions} />
            </div>
          )} */}
        <Topbar2 handleBtnClick={handleEnquiry} showActionButton={!(location.pathname === routesLinks.homev1 || location.pathname === routesLinks.homev2)} />
        {pages.map((Page, idx) => {
          const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
          useEffect(() => {
            if (inView && !visiblePages.includes(idx + 1) && idx + 1 < pages.length) {
              setVisiblePages((prev) => [...prev, idx + 1]);
            }
          }, [inView, idx, visiblePages]);
          return visiblePages.includes(idx) ? (
            <div ref={ref} key={idx}>
              <Suspense fallback={<div className="spinner"></div>}>{Page}</Suspense>
            </div>
          ) : null;
        })}
      </div>

      {isMobile && (
        location.pathname === routesLinks.homev1 ||
        location.pathname === routesLinks.homev2
      ) && (
          <div className={navbarStyles.floatingButtonContainer}>
            <ActionButton
              title="Enquire Now"
              styleContainer="enquirebutton"
              handleBtnClick={handleEnquiry}
              icon={logo}
            />
          </div>
        )}


      {/* Enquiry Modal */}
      {enquiryOpen && (
        isMobile ? (
          <EnquiryDrawer
            options={options}
            setEnquiryOpen={setEnquiryOpen}
            enquiryOpen={enquiryOpen}
            onOptionSelect={onOptionSelect}
          />
        ) : (
          <EnquiryDropdown
            options={options}
            setEnquiryOpen={setEnquiryOpen}
            enquiryOpen={enquiryOpen}
            actionButtonRef={actionButtonRef}
            onOptionSelect={onOptionSelect}
          />
        )
      )}

      {/* School Form Modal */}
      {openSchoolForm && (
        <FormModal isOpen={openSchoolForm} onRequestClose={handleCloseForm}>
          <SchoolAiPage
            onClose={handleCloseForm}
            otpRequired={location.pathname !== routesLinks.homev2}
          />
        </FormModal>
      )}
      {/* ZohoIQ Widget */}
      {!initialLoader && <ZohoIQWidget />}
    </div>
  );
};

export default LandingPageV1;
